module.exports = __webpack_public_path__ + "img/qr-scaner.ff17b45b.png";